import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

export default function AdminProtectedRoute({ children }) {
  const { isAuthenticated, admin, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="admin-loading"
        className="min-h-screen flex items-center justify-center bg-[#f7fafc]"
      >
        <div className="text-[13px] font-semibold text-[#5b6b7a]">Chargement…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  // Partners must go to their own space, not the admin one
  if (admin?.role === "partner") {
    return <Navigate to="/partenaire" replace />;
  }

  return children;
}
